import {
  PieChartOutlined,
  UnorderedListOutlined,
  AppstoreAddOutlined,
  EditOutlined,
  MessageOutlined,
  ShoppingCartOutlined,
  NotificationOutlined,
} from '@ant-design/icons';
import MainLayout from '../layout';
// GeneralViews
import Login from '../pages/Login';
import SignUp from '../pages/SignUp';
import Menu from '../pages/Menu';
import CategoryDetail from '../pages/CategoryDetail';
import ProductDetail from '../pages/ProductDetail';
import CategoryCreate from '../pages/CategoryCreate';
import ProductCreate from '../pages/ProductCreate';
import Categories from '../pages/Categories';
import Subcategories from '../pages/Subcategories';
import SubcategoryCreate from '../pages/SubcategoryCreate';
import SubcategoryDetail from '../pages/SubcategoryDetail';
import SendMarketingMessage from '../pages/SendMarketingMessage';
import Banners from '../pages/Banners';
import Brands from '../pages/Brands';
import BrandCreate from '../pages/BrandCreate';
import BrandDetail from '../pages/BrandDetail';
import Addons from '../pages/Addons';
import AddonCreate from '../pages/AddonCreate';
import AddonDetail from '../pages/AddonDetail';
import Discounts from '../pages/Discounts';
import BulkProductSearch from '../pages/BulkProductSearch/BulkProductSearch';
import PricingTiers from '../pages/PricingTiers';
import PricingTierDetail from '../pages/PricingTierDetail';
import Coupons from '../pages/Coupons';
import CouponCreate from '../pages/CouponCreate';
import CouponDetail from '../pages/CouponDetail';
import Settings from '../pages/Settings';
import Orders from '../pages/Orders';
import Notifications from '../pages/Notifications';
import NotificationCreate from '../pages/NotificationCreate';
import MenuPaginated from '../pages/Menu/MenuPaginated';
//import Tags from '../pages/Tags';
//import TagDetail from '../pages/TagDetail';
//import TagCreate from '../pages/TagCreate';

export const authRoutes = [
  // {
  //   path: '/',
  //   component: Menu,
  //   name: 'Menu',
  //   icon: PieChartOutlined,
  //   showAlways: true,
  // },
  {
    path: '/',
    component: MenuPaginated,
    name: 'Home',
    icon: PieChartOutlined,
    showAlways: true,
  },
  {
    path: '/banners',
    component: Banners,
    name: 'Banners',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/categories',
    component: Categories,
    name: 'Categories',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/subcategories',
    component: Subcategories,
    name: 'Subcategories',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/brands',
    component: Brands,
    name: 'Brands',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/addons',
    component: Addons,
    name: 'Addons',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/discounts',
    component: Discounts,
    name: 'Discounts',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/products/bulk-search',
    component: BulkProductSearch,
    name: 'Bulk Product Search',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/pricing-tiers',
    component: PricingTiers,
    name: 'Pricing Tiers',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/coupons',
    component: Coupons,
    name: 'Coupons',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/notifications',
    component: Notifications,
    name: 'Notifications',
    icon: NotificationOutlined,
    showAlways: true,
  },
  // {
  //   path: '/whatsapp/send-marketing-message',
  //   component: SendMarketingMessage,
  //   name: 'Send Marketing Message',
  //   icon: MessageOutlined,
  //   showAlways: true,
  // },
  {
    path: '/orders',
    component: Orders,
    name: 'Orders',
    icon: ShoppingCartOutlined,
    showAlways: true,
  },
  {
    path: '/product-create',
    component: ProductCreate,
    name: 'Product Create',
    icon: AppstoreAddOutlined,
    showAlways: false,
  },
  {
    path: '/category-create',
    component: CategoryCreate,
    name: 'Category Create',
    icon: AppstoreAddOutlined,
    showAlways: false,
  },
  {
    path: '/subcategory-create',
    component: SubcategoryCreate,
    name: 'Subcategory Create',
    icon: AppstoreAddOutlined,
    showAlways: false,
  },
  {
    path: '/product/:id',
    component: ProductDetail,
    name: 'Product Detail',
    icon: EditOutlined,
    showAlways: false,
  },
  {
    path: '/category/:id',
    component: CategoryDetail,
    name: 'Category Detail',
    icon: EditOutlined,
    showAlways: false,
  },
  // TODO: subcategory detail
  {
    path: '/subcategory/:id',
    component: SubcategoryDetail,
    name: 'Subcategory Detail',
    icon: EditOutlined,
    showAlways: false,
  },
  {
    path: '/brand-create',
    component: BrandCreate,
    name: 'Brand Create',
    icon: AppstoreAddOutlined,
    showAlways: false,
  },
  {
    path: '/brand/:id',
    component: BrandDetail,
    name: 'Brand Detail',
    icon: EditOutlined,
    showAlways: false,
  },
  {
    path: '/addon-create',
    component: AddonCreate,
    name: 'Addon Create',
    icon: AppstoreAddOutlined,
    showAlways: false,
  },
  {
    path: '/addon/:id',
    component: AddonDetail,
    name: 'Addon Detail',
    icon: EditOutlined,
    showAlways: false,
  },
  {
    path: '/coupon-create',
    component: CouponCreate,
    name: 'Coupon Create',
    icon: AppstoreAddOutlined,
    showAlways: false,
  },
  {
    path: '/coupons/:id',
    component: CouponDetail,
    name: 'Coupon Detail',
    icon: EditOutlined,
    showAlways: false,
  },
  {
    path: '/pricing-tiers/:tierId',
    component: PricingTierDetail,
    name: 'Pricing Tier Detail',
    icon: EditOutlined,
    showAlways: false,
  },
  {
    path: '/settings',
    component: Settings,
    name: 'Settings',
    showAlways: false,
  },
  {
    path: '/notification-create',
    component: NotificationCreate,
    name: 'Notification Create',
    icon: AppstoreAddOutlined,
    showAlways: false,
  },
  /* {
    path: '/tags',
    component: Tags,
    name: 'Tags',
    icon: UnorderedListOutlined,
    showAlways: true,
  },
  {
    path: '/tag-create',
    component: TagCreate,
    name: 'Tag Create',
    icon: AppstoreAddOutlined,
    showAlways: false,
  },
  {
    path: '/tag/:id',
    component: TagDetail,
    name: 'Tag Detail',
    icon: EditOutlined,
    showAlways: false,
  }, */
];

export const baseRoutes = [
  {
    path: '/login',
    component: Login,
    name: 'Dashboard',
    noAuth: true,
  },
  {
    path: '/sign-up',
    component: SignUp,
    name: 'Sign Up',
    noAuth: true,
  },
];
